/* eslint-disable camelcase */
import {
  takeLatest, select, call, put,
} from 'redux-saga/effects';
import {
  GET_VEHICLE_CARD_INFORMATION,
  NEGOTIABILITY,
} from '../actions/car-detail';
import {
  getVehicleCardInformation,
  negotiability,
} from '../../utils/apis/car-detail';
import { SPINNER_OPEN, SPINNER_CLOSE } from '../actions/types';

function* getVehicleCardInformationFn({ payload: body }) {
  try {
    yield put({
      type: SPINNER_OPEN,
    });

    const { email } = yield select(({ login }) => (login.logged
      ? { email: login.email }
      : { email: null }));

    const { data } = yield call(
      getVehicleCardInformation,
      {
        ...body,
        ...(email ? { email } : {}),
      },
    );

    yield put({
      type: GET_VEHICLE_CARD_INFORMATION._SUCCESS,
      newState: { ...data },
    });
  } catch (e) {
    yield put({ type: GET_VEHICLE_CARD_INFORMATION._ERROR, error: e });
  } finally {
    yield put({ type: SPINNER_CLOSE });
  }
}

function* watchGetVehicleCardInformation() {
  yield takeLatest(
    GET_VEHICLE_CARD_INFORMATION._REQUEST,
    getVehicleCardInformationFn,
  );
}

function* negotiabilityFn({ payload: body }) {
  try {
    yield put({
      type: SPINNER_OPEN,
    });

    const { email } = yield select(({ login }) => (login.logged
      ? { email: login.email }
      : { email: null }));

    if (!email) {
      throw new Error('NOT_LOGGED');
    }
    yield call(negotiability, {
      ...body,
      ...(email ? { email } : {}),
    });
    yield put({
      type: GET_VEHICLE_CARD_INFORMATION._REQUEST,
      payload: { email: body.email, vin: body.vin },
    });
  } catch (e) {
    yield put({ type: NEGOTIABILITY._ERROR, error: e });
  } finally {
    yield put({ type: SPINNER_CLOSE });
  }
}

function* watchNegotiability() {
  yield takeLatest(NEGOTIABILITY._REQUEST, negotiabilityFn);
}

export default [watchGetVehicleCardInformation, watchNegotiability];
